import React from 'react';

import Card from '../../shared/components/UIElements/Card';
import FileItem from './FileItem';
import Button from '../../shared/components/FormElements/Button';
import './FileList.css';

const FileList = props => {
    
    if (props.items.length === 0) {
        return (
            <div className = "place-list place-list--empty">
                <Card>
                    <h2> No files found. Maybe upload one? </h2>
                    <Button to="/files/new"> Files Upload </Button>
                </Card>        
            </div>
        );
    }

    return (
        <ul className = "place-list">
            {props.items.map (file => (
                <FileItem
                    key = {file.id}
                    id = {file.id}
                    image={file.image}
                    //title={place.title}
                    mimeType={file.mimeType} // Added this for the pdf files
                    originalName={file.originalName} // Added this for the pdf files
                    //description={place.description}
                    //address={place.address}
                    creatorId={file.creator}
                    //coordinates={place.location}
                    onDelete={props.onDeleteFile}
                />
            ))}
        </ul>
    );
};

export default FileList;